import { render, staticRenderFns } from "./mingxi.vue?vue&type=template&id=2e738288"
import script from "./mingxi.vue?vue&type=script&lang=js"
export * from "./mingxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports